import React from 'react'
import { withRouter } from 'react-router-dom'
import { buildBikeURL } from '../../../utils'
import NumberFormat from 'react-number-format'
import getSymbolFromCurrency from 'currency-symbol-map'
import {
  SEARCH_IMAGE_PARAMS,
} from '../../../../constants/images/sizesAndQuality'
import {
  CLOUDINARY_API_KEY,
  CLOUDINARY_NAME,
} from '../../../../constants/images/cloudinary'
import { convertCents, buildDatesForUrl } from '../../../utils'
import { multiDayPricingList } from 'components/utils/multiDayPricingList'
import { Link } from 'react-router-dom'
import cloudinary from 'cloudinary-core'
import ProgressImage from '../../../elements/progressiveImages'
import FavoritesButton from '../../../../components/bikes/addToFavorites/favoritesButton'
import './searchCard.sass'
import Slider from 'react-slick'
import {
  canShowCrossedDailyRentalPrice,
  findPriceForLoggedInUser,
  findPriceForNonLoggedInUser
} from '../searchUtil.js'
const cl = new cloudinary.Cloudinary({
  cloud_name: CLOUDINARY_NAME,
  api_key: CLOUDINARY_API_KEY,
})

const testTags = (data) => {
  const tagsToTest = ['is_newly_listed', 'can_book_instantly'] //add more tests here

  let hasTags = false

  for (let i = 0; i < tagsToTest.length; i++) {
    if (data[tagsToTest[i]]) {
      hasTags = true
      break
    }
  }

  return hasTags
}

const NextArrow = (props) => {
  const { onClick } = props
  return (
    <i
      className="twisted-map-next fal fa-angle-right"
      onClick={onClick}
      style={{ fontSize: '38px' }}
    ></i>
  )
}

const PrevArrow = (props) => {
  const { onClick } = props
  return (
    <i
      className="twisted-map-prev fal fa-angle-left"
      onClick={onClick}
      style={{ fontSize: '38px' }}
    ></i>
  )
}

class SearchCard extends React.Component {
  buildCardAltTag = () => {
    const { cardInfo } = this.props

    let altTag =
      cardInfo.bike_year.toString() +
      ' ' +
      cardInfo.bike_make +
      ' ' +
      cardInfo.bike_model +
      ' motorcycle rental in ' +
      cardInfo.bike_location.city +
      ', ' +
      cardInfo.bike_location.region_abbreviation

    return altTag
  }

  render() {
    const {
      cardInfo,
      className,
      //focusedResult,
      //hideName,
      //hideLocation,
      startDate,
      endDate,
      titleSize,
      isSearchPage,
      isAuthenticated,
      isTripTaken,
      currentIndex
    } = this.props

    const { bike_gear, bike_can_deliver } = cardInfo
    //this can
    let focusClass = ''
    if (this.props.focusedResult === cardInfo.bike_owner_id) {
      focusClass = ' result-hover-active-card'
    }

    let multi_day_pricing_list = multiDayPricingList(
      cardInfo?.multi_day_pricing?.length > 0 ?
        cardInfo?.multi_day_pricing
        : null
    )

    var sliderSettings = {
      dots: false,
      infinite: true,
      speed: 700,
      lazyLoad: "ondemand",
      slidesToShow: 1,
      slidesToScroll: 1,
      nextArrow: <NextArrow />,
      prevArrow: <PrevArrow />,
      innerSlider: undefined,
    }

    return (
      <div
        className={'searchCard column ' + className + focusClass}
        // onMouseEnter={() => this.props.onHover(cardInfo.bike_owner_id)}
        // onMouseLeave={() => this.props.onHover(null)}
      >
        <Link
          to={cardInfo?.bike_url ? cardInfo?.bike_url + buildDatesForUrl(startDate, endDate) :
            buildBikeURL({
              country: cardInfo.bike_location.country_abbreviation,
              region: cardInfo.bike_location.region_abbreviation,
              city: cardInfo.bike_location.city,
              year: cardInfo.bike_year.toString(),
              make: cardInfo.bike_make,
              model: cardInfo.bike_model,
              bikeID: cardInfo.bike_id,
              isPartner: this.props.isPartner,
            }) + buildDatesForUrl(startDate, endDate)
          }
          target="_blank"
        >
          <div className="search-cardInfo-images-price">
            {isSearchPage && cardInfo?.bike_images?.length > 0 ? (
              <Slider key={Date.now()} {...sliderSettings}>
                {cardInfo?.bike_images.map((bike, index) => (
                  <ProgressImage
                    key={bike.cloudinary_public_id}
                    overlaySrc={cl.url(
                      bike.cloudinary_public_id,
                      SEARCH_IMAGE_PARAMS
                    )}
                    src={cl.url(bike.cloudinary_public_id, SEARCH_IMAGE_PARAMS)}
                    alt={this.buildCardAltTag()}
                    className="search-cardInfo-image"
                    currentImage={index}
                  />
                ))}
              </Slider>
            ) : (
              <ProgressImage
                key={0}
                overlaySrc={cl.url(
                  cardInfo.bike_image_cloudinary_public_id,
                  SEARCH_IMAGE_PARAMS
                )}
                src={cl.url(
                  cardInfo.bike_image_cloudinary_public_id,
                  SEARCH_IMAGE_PARAMS
                )}
                alt={this.buildCardAltTag()}
                className="search-cardInfo-image"
                currentImage={0}
              />
            )}
            {cardInfo.last_inspection_date && (
              <div className="inspection-tag-container">
                <div className="inspection-tag">
                  {/* <div className="inspection-tag-content has-text-centered has-text-weight-semibold">
                    <div className="inspection-tag-date mt-1">
                      {cardInfo.last_inspection_date_formatted}
                    </div>
                  </div> */}
                </div>
              </div>
            )}
            <div className="search-cardInfo-price-tag tag is-large has-text-weight-bold is-primary">
              {cardInfo.can_book_instantly && (
                <i className="fas fa-bolt bolt-custom-icon"></i>
              )}
              {(
                (isAuthenticated && isTripTaken && canShowCrossedDailyRentalPrice(
                  startDate, endDate, cardInfo.has_multiday, multi_day_pricing_list
                )) || (isAuthenticated && !isTripTaken) || !isAuthenticated
              ) && (
                <span className="multiday-cross-out is-inline-block mr-1">
                  <NumberFormat
                    defaultValue={convertCents(cardInfo.day_price_cents)}
                    displayType={'text'}
                    decimalScale={0}
                    thousandSeparator={true}
                    prefix={getSymbolFromCurrency(cardInfo.day_price_currency)}
                  />
                </span>
              )}
              <NumberFormat
                defaultValue={convertCents(!isAuthenticated ?  findPriceForNonLoggedInUser(
                  cardInfo.day_price_cents, startDate, endDate
                ) : findPriceForLoggedInUser(
                  cardInfo, startDate, endDate, multi_day_pricing_list, isTripTaken
                ))}
                displayType={'text'}
                decimalScale={0}
                thousandSeparator={true}
                prefix={getSymbolFromCurrency(cardInfo.day_price_currency)}
              />
              <span className="per-day-flag is-size-7">&nbsp;/ day</span>
            </div>
          </div>

          <div className="search-card-title-distance-wrap">
            <div
              className={`search-card-title ${titleSize} has-text-dark has-text-weight-extra-bold`}
            >
              {cardInfo.bike_year} {cardInfo.bike_make} {cardInfo.bike_model}
              <div className="search-card-rating-star has-text-grey">
                {cardInfo.ratings_count > 0 &&
                  <div className="search-card-rating-score has-text-weight-bold">
                    {cardInfo.average_rating > 0
                      ? cardInfo.average_rating
                      : null}
                  </div>
                }
                {cardInfo.ratings_count > 0 && <i className="fa fa-star search-card-bike-rating"></i>}{' '}
                {cardInfo.total_trips_taken > 0 && (
                  <div className="search-card-rating-count">
                    {cardInfo.total_trips_taken === 1
                      ? '(' +
                      cardInfo.total_trips_taken.toString() +
                      ' trip taken)'
                      : null}
                    {cardInfo.total_trips_taken > 1
                      ? '(' +
                      cardInfo.total_trips_taken.toString() +
                      ' trips taken)'
                      : null}
                  </div>
                )}
              </div>
            </div>
            {this.props.showDistance && (
              <div className="search-card-distance has-text-dark has-text-weight-bold">
                {cardInfo.bike_distance} mi away
                <FavoritesButton
                  url={'https://www.twistedroad.com' + cardInfo.bike_url}
                  bikeID={cardInfo.bike_uuid_id}
                  bikeAddedToWishlist={cardInfo.in_wishlist}
                  bikePrettyID={cardInfo.bike_id}
                  isSearchCardFavourite={true}
                />
              </div>
            )}
          </div>
          {(bike_gear?.helmets?.length > 0 || bike_can_deliver) && (
            <span style={{ display: 'inline-flex', alignItems: 'center' }}>
              { bike_can_deliver && <img className='mb-1' src="/static/images/bikeProfileSectionImages/bike.jpg" alt="bike-image" style={{ marginRight: '0.4rem',verticalAlign: 'middle', width: 28, height: 16 }}/> }
              { bike_gear?.helmets?.length > 0 && <img className='mb-1' src="/static/images/bikeProfileSectionImages/helmet.JPG" alt="helmet-image" style={{ verticalAlign: 'middle', width: 18, height: 18 }}/> }
              <span className='delivey-helmet-info' style={{ marginLeft: '0.4rem' }}>
                {bike_can_deliver && bike_gear?.helmets?.length > 0 && 'Delivery & Helmets Available'}
                {bike_can_deliver && !bike_gear?.helmets?.length > 0 && 'Delivery Available'}
                {!bike_can_deliver && bike_gear?.helmets?.length > 0 && 'Helmets Available' }
              </span>
            </span>
          )}

          {testTags(cardInfo) && (
            <div className="tags are-normal mt-2">
              {cardInfo.is_newly_listed && (
                <span className="black-tag tag is-rounded">
                  <i className="fas fa-flag-checkered bolt-custom-icon"></i>
                  Newly Listed
                </span>
              )}
              {cardInfo.can_book_instantly && (
                <span className="black-tag tag is-rounded">
                  <i className="fas fa-bolt bolt-custom-icon"></i>Book Instantly
                </span>
              )}
            </div>
          )}
        </Link>
      </div>
    )
  }
}

export default withRouter(SearchCard)

SearchCard.defaultProps = {
  cardInfo: null,
  isPartner: false,
  className: '',
  startDate: null,
  endDate: null,
  showDistance: true,
  onHover: function () { },
  focusedResult: null,
  hideName: false,
  hideLocation: false,
  titleSize: 'is-size-4',
}
